import {Breadcrumb, Button, Form, Modal, Input, Spin, InputNumber, Popconfirm, message, Space, Select} from "antd";
import Header from "../../components/dashboard/header";
import {DashboardOutlined, PlusSquareOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {BsGraphUp} from "react-icons/bs";
import {useState, useRef, useContext, useEffect} from "react"
import DataTable from "../../components/common/table";
import {Link} from "react-router-dom";
import RefreshContext from "../../context/refreshContext";
import {extractValueFromInputRef} from "../../helpers/dom";
import {
    useCreateLevel,
    useDeleteLevel,
    useGetAllLevels,
    useUpdateLevel
} from "../../hooks/payrollData/payrollDataQuery";
import {usePVTypes} from "../../hooks/voucherTypes/voucherTypeQuery";


const levelTableColumns = [
    {
        title: "S/N",
        key: "s/n",
        render: (_, __, idx) => idx + 1
    },
    {
        title: "Title",
        key: "title",
        dataIndex: "title"
    },
    {
        title: "Value",
        key: "value",
        dataIndex: "value"
    },
    {
        title: "Salary",
        key: "level",
        dataIndex: "salaryAmount"
    },
    {
        title: "Salary Structure",
        key: "salaryStructure",
        dataIndex: "salaryStructure",
        render: (_, { salaryStructure }) => salaryStructure?.title
    },
    {
        title: "Actions",
        key: "actions",
        render: (_, level) => (<LevelEdit level={level}/>)
    }
]


function LevelEdit({level}) {
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [salaryStructure, setSalaryStructure] = useState(null)
    const {structures} = usePVTypes()

    const {flag, setFlag} = useContext(RefreshContext);

    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const levelRef = useRef(null);

    const updateLevel = useUpdateLevel();
    const deleteLevel = useDeleteLevel();


    const confirmDeleteLevel = async () => {
        await deleteLevel(level.id);
        setFlag(!flag);
        message.success("Level deleted Successfully");
    }


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            salaryAmount: levelRef.current.value,
            salaryStructure: salaryStructure
        }
        await updateLevel(level.id, payload);
        message.success("Level updated successfully");
        setFlag(!flag);
        setIsEditOpen(false);
    }


    return (
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={() => setIsEditOpen(true)}>
                    <EditOutlined/>
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this level"
                    description="Are you sure to delete this ?"
                    onConfirm={confirmDeleteLevel}
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined/>
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title={"Update Level"} open={isEditOpen} footer={null} onCancel={() => setIsEditOpen(false)}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "70vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <Form wrapperCol={{
                        span: 24,
                    }}
                          initialValues={{...level, levelValue: level?.salaryAmount}}
                    >
                        <Form.Item name="title">
                            <Input ref={titleRef} placeholder="Enter Title"/>
                        </Form.Item>
                        <Form.Item name="value">
                            <Input ref={valueRef} placeholder="Enter Value"/>
                        </Form.Item>
                        <Form.Item name="levelValue">
                            <InputNumber style={{width: "100%"}} ref={levelRef} placeholder="Enter Level"/>
                        </Form.Item>
                        <Form.Item name="salaryStructure">
                            <Select placeholder="Salary structure" onChange={e => setSalaryStructure(e)}>
                                {
                                    structures.map((s, idx) => (
                                        <Select.Option key={idx} value={s.id}>
                                            {s.title}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button style={{backgroundColor: "green"}} size="large" type="primary" htmlType="submit"
                                    onClick={handleSubmit}>
                                Update Step
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}


export default function Level() {
    const [isOpen, setIsOpen] = useState(false);
    const [salaryStructure, setSalaryStructure] = useState(null)
    const [filterStructure, setFilterStructure] = useState(null)

    const [tmpLevels, setTmpLevels] = useState([])


    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const levelRef = useRef(null);


    const showCreateModal = () => setIsOpen(true);
    const hideCreateModal = () => setIsOpen(false);

    const {flag, setFlag} = useContext(RefreshContext);

    const createLevel = useCreateLevel();


    const {loading, levels} = useGetAllLevels(flag);

    const { structures } = usePVTypes()
    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            salaryAmount: levelRef.current.value,
            salaryStructure: salaryStructure
        }
        await createLevel(payload);
        setFlag(!flag);
        message.success("Level created successfully");
        setIsOpen(false);
    }

    useEffect(() => {
        setTmpLevels(levels.filter(e => (filterStructure && e.salaryStructure?.id === filterStructure) || filterStructure == null))
    }, [levels, filterStructure]);

    const handleLoading = () => {
    }


    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">
                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>
                                    Dashboard
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <BsGraphUp/>
                                <Link to="/dashboard/level">
                                    Level
                                </Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div>
                            <Select
                                showSearch
                                placeholder="Salary Structure"
                                onChange={e => setFilterStructure(e)}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                style={{
                                    width: 200,
                                }}
                                options={[...structures.map(s => ({value: s.id, label: s.title}))]}
                            />
                        </div>
                        <div style={{display: 'flex', gap: '1em'}}>
                            <Button style={{backgroundColor: "green", color: "#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined/>
                                Add Level
                            </Button>
                        </div>
                    </div>
                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={levelTableColumns} data={tmpLevels}/>
                        </Spin>
                    </div>
                </div>
            </div>

            <Modal title="Add Level" open={isOpen} footer={null} onCancel={hideCreateModal}>
                <div style={{
                    marginTop: "3em",
                    maxHeight: "70vh",
                    overflowY: "scroll",
                    paddingLeft: "1em",
                    paddingRight: "1em"
                }}>
                    <Form wrapperCol={{
                        span: 24,
                    }}>

                        <Form.Item>
                            <Input
                                ref={titleRef}
                                placeholder="Enter Title" rules={[
                                {
                                    required: true,
                                    message: 'Please input title'
                                },
                            ]}/>
                        </Form.Item>
                        <Form.Item>
                            <Input placeholder="Enter Value" ref={valueRef}/>
                        </Form.Item>
                        <Form.Item>
                            <InputNumber
                                ref={levelRef}
                                style={{width: "100%"}} placeholder="Salary amount"/>
                        </Form.Item>
                        <Form.Item name="salaryStructure">
                            <Select placeholder="Salary structure" onChange={e => setSalaryStructure(e)}>
                                {
                                    structures.map((s, idx) => (
                                        <Select.Option key={idx} value={s.id}>
                                            {s.title}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item wrapperCol={{
                            span: 8,
                            offset: 20
                        }}>
                            <Button type="primary" onClick={handleSubmit}>
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
